module.exports = __webpack_public_path__ + "static/media/groupNew.84ac8aba.png";